import { IBaseAppointmentCategory } from '../../../interfaces';
import { BaseAppointmentCategoryToTreatmentCategoryMappingHandler } from '../../../mappings/appointment-category-to-treatment-category';
import {
  AppointmentCategorySourceEntity,
  ExactAppointmentCategory,
  IExactAppointmentCategory,
} from '../../source/entities/appointment-category';

export class AppointmentCategoryToTreatmentCategoryMappingHandler extends BaseAppointmentCategoryToTreatmentCategoryMappingHandler<
  ExactAppointmentCategory,
  AppointmentCategorySourceEntity
> {
  sourceEntity = new AppointmentCategorySourceEntity();
  translateFn = (
    record: IExactAppointmentCategory
  ): IBaseAppointmentCategory => ({
    id: record.id.toString(),
    name: record.name,
  });
}
